<template>
    <div>
        <b-tab no-body :title=" $tc('message.antecedents',2) " :active="pathHas($tc('message.antecedents',2))">

            <b-link class="ml-4" variant="primary" @click="toAntecedent" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                <i class="fas fa-plus-circle edit-icon"></i>{{ $tc('message.antecedents', 1) }}
            </b-link>

            <div>
                <div v-if="!mobileView">
                    <vue-good-table id="antecedent" v-if="notEmpty(antecedentsRows)" :columns="antecedentsColumns" :rows="antecedentsRows" :search-options="enabled" :pagination-options="paginationOptions" @on-row-click="onAntecedentRowClick" />
                </div>
                <div class="container fluid" v-else>
                    <div id="table-demo"> <!-- v-if="mobileView" -->
                        <div class="ltemp--content--box border border-1 px-2 px-md-4 py-2 my-2 mx-md-3 rounded bg-white" v-for="(row, x) in antecedentsRows" :key="x"  @click="onAntecedentRowClickMobile(row)">
                            <div class="trajet__info bg-white mt-2 px-2" > <!-- v-for="(item, index) in ligne_temps" :key="index" -->
                                <div class="trajet__info--text h-100 d-flex align-items-center justify-content-between fs-6">
                                    <span class="d-flex align-items-center text-gray">
                                        <i class="fa fa-calendar" aria-hidden="true"></i>
                                        <span class="px-1 mr-2">{{row.date}}</span>
                                        <!-- <span class="px-1">{{row.type}}</span> -->
                                        <span class="px-1">{{row.description}}</span>
                                        <span class="mr-3">
                                            <b-button class="border-0 p-0 d-flex align-items-center shadow-none bg-transparent text-primary"><!-- @click="onAntecedentRowClickMobile(row.slug) " -->
                                                <span class="d-none d-md-block">Voir</span>
                                                <i class="fa fa-eye" aria-hidden="true"></i>
                                            </b-button> 
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </b-tab>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import moment from "moment";
export default {
    name: "Antecedent",
    computed: {
         ...mapGetters(["file"]),

        mMedicalFile: function () {
            return _.isUndefined(this.file) ? [] : this.file;
        },
        mAntecedents: function () {
            let mArray = [];
            mArray = typeof this.mMedicalFile.antecedents == "object" ? this.mMedicalFile.antecedents : [];

            let cMedecines = this.mMedicalFile.consultations_medecine;
            let cCardiologies = this.mMedicalFile.cardiologies;

            _.forEach(cCardiologies, function (cardiologie) {
                if (!_.isNull(cardiologie.conclusion) && cardiologie.conclusion !== 'null') {
                    let c = {}
                    c.type = 'Consultation';
                    c.description = cardiologie.conclusion;
                    c.date = moment(cardiologie.updated_at).format('YYYY-MM-DD');
                    c.cardiology = cardiologie.slug;
                    mArray.push(c);
                }
            });

            _.forEach(cMedecines, function (medecine) {
                _.forEach(medecine.conclusions, function (conclusion) {
                    let m = {};
                    m.type = 'Consultation';
                    m.description = conclusion.description;
                    m.date = moment(conclusion.updated_at).format('YYYY-MM-DD');
                    m.medecine = medecine.slug;
                    mArray.push(m);
                })
            })

            return mArray;
        },
        antecedentsRows: function () {

            return this.mAntecedents
        },
    },
    props: ['hasAdminRole', 'hasMedecinControleRole', 'hasAssistante', 'hasPraticienRole', 'file_id'],
    data() {
        return {
            mobileView: true,
            antecedentsColumns: [{
                    label: this.$i18n.tc('message.types', 1),
                    field: 'type',
                },
                {
                    label: 'Description',
                    field: 'description',
                    html: true,
                },
                {
                    label: this.$i18n.t('message.startDate'),
                    field: 'date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd/MM/yyyy',
                },
            ],
            paginationOptions: {
                enabled: true,
                mode: 'records',
                perPageDropdown: [3, 6, 10]
            },

            enabled: {
                enabled: true
            },

            sort: {
                enabled: true,
                initialSortBy: {
                    field: 'date',
                    type: 'desc'
                }
            },
            
        }
    },
    validations() {
        return {
            form: {
                responsable:{},
            }
        }
	},
    methods: {
        handleView() {
            this.mobileView = window.innerWidth <= 990;
        },
        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },
        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },  
        toAntecedent() {
            this.$router.push({
                name: 'add-antecedent',
                params: {
                    file: this.file_id
                }
            })
        },
        onAntecedentRowClick(params) {
            if (params.row.hasOwnProperty('medecine')) {
                this.$router.push({
                    name: 'consultation-general',
                    params: {
                        consultation: params.row.medecine
                    }
                });
            } else if (params.row.hasOwnProperty('cardiology')) {
                this.$router.push({
                    name: 'consultation-cardiology',
                    params: {
                        consultation: params.row.cardiology
                    }
                });
            } else {
                this.$router.push({
                    name: 'antecedent',
                    params: {
                        antecedent: params.row.slug,
                        file: this.file_id
                    }
                });
            }
        },

        onAntecedentRowClickMobile(params) {
            // console.log(params);
            if (params.hasOwnProperty('medecine')) {
                this.$router.push({
                    name: 'consultation-general',
                    params: {
                        consultation: params.medecine
                    }
                });
            } else if (params.hasOwnProperty('cardiology')) {
                this.$router.push({
                    name: 'consultation-cardiology',
                    params: {
                        consultation: params.cardiology
                    }
                });
            } else {
                this.$router.push({
                    name: 'antecedent',
                    params: {
                        antecedent: params.slug,
                        file: this.file_id
                    }
                });
            }
        },
        pathHas(element) {
        let result = (this.$route.fullPath).includes(element);
            if (result) {
                if ($('#' + element).length) {
                    document.getElementById(element).scrollIntoView(top);
                }
            }

            return result;
        },
        notEmpty(item) {
            return item.length > 0;
        },
    },
    created() {
        this.handleView();
        window.addEventListener('resize', this.handleView);
    },
    mounted() {
        
    }
}
</script>
<style lang="">
    
</style>